/**
 * Which data is on screen, stated permanently.
 *
 * The demo is a public URL and one build now serves both invented people and
 * real client records. Nothing else on the page distinguishes them — the
 * layout, the charts and the twins are identical — so without this a reader
 * cannot tell whether "Daniel Ovesen" is a fixture or somebody's patient, and
 * a coach cannot tell whether a note they are writing is real.
 *
 * Live wears the projected palette, the same treatment every other
 * not-quite-what-it-seems thing in the app carries.
 */
export const DataModeBanner: React.FC<{
  mode: 'mock' | 'live';
  onSwitch: (mode: 'mock' | 'live') => void;
}> = ({ mode, onSwitch }) => {
  const live = mode === 'live';
  return (
    <div
      data-testid="data-mode-banner"
      className={`z-50 flex items-center justify-center gap-3 px-4 py-1.5 ${
        live
          ? 'bg-[hsl(var(--projected))] text-white'
          : 'bg-accent text-accent-foreground'
      }`}
    >
      <span className="font-mono text-[9.5px] font-medium uppercase tracking-[0.14em]">
        {live ? 'Live data' : 'Demo data'}
      </span>
      <span className="text-[11px]">
        {live
          ? 'Real client records. Edits and deletions are real.'
          : 'Invented people. Nothing here is a real client.'}
      </span>
      <button
        type="button"
        onClick={() => onSwitch(live ? 'mock' : 'live')}
        data-testid="data-mode-switch"
        className={`rounded border px-2 py-0.5 text-[10px] font-medium transition-colors ${
          live
            ? 'border-white/40 hover:bg-white hover:text-[hsl(var(--projected))]'
            : 'border-accent-foreground/30 hover:bg-accent-foreground hover:text-accent'
        }`}
      >
        {live ? 'Show demo data' : 'Use live data'}
      </button>
    </div>
  );
};
